// Promotion banner: dismissal only.
//
// This file previously ran the scarcity counter -- it read a "remaining" count
// from localStorage, POSTed to /apps/offer-redeem, and on failure (which was
// always, since no backend was ever deployed) silently decremented the local
// copy so each visitor watched their own private countdown. It also jittered
// the banner's position by a random 10-30px on every page load to catch the
// eye. All of that is gone: the count was not real, and the jitter was a dark
// pattern, not a feature.
//
// The offer's end date is now enforced server-side in snippets/offer-banner.liquid,
// so an expired promotion is never rendered at all. Nothing here can extend,
// shorten, or fake it. Do not reintroduce client-side offer state.
(function () {
  'use strict';

  var DISMISS_KEY = 'offer_dismissed_until';

  // Remembering a dismissal is a courtesy to the visitor, not offer state --
  // it only ever hides the banner, never changes what it claims.
  function readDismissedUntil() {
    try {
      var v = parseInt(localStorage.getItem(DISMISS_KEY), 10);
      return Number.isInteger(v) ? v : 0;
    } catch (e) {
      return 0; // private mode / blocked storage: just show the banner
    }
  }

  function remember(days) {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now() + days * 864e5));
    } catch (e) {
      /* not worth failing the page over */
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.querySelector('.offer-banner');
    if (!banner) return;

    if (Date.now() < readDismissedUntil()) {
      banner.hidden = true;
      return;
    }

    var close = banner.querySelector('.offer-close');
    if (close) {
      close.addEventListener('click', function () {
        banner.hidden = true;
        remember(7);
      });
    }
  });
})();
